export default __webpack_public_path__ + "static/icon-32-2-1a642b0e82614a2d88282652827a6b56.png";